import { literal, object, TypeOf } from 'zod';

import { ElementType } from '../common';

/* ---------------------------- QrCodePageElement --------------------------- */

export const QrCodePageElement = object({
    type: literal(ElementType.QrCode),
});

export type QrCodePageElement = TypeOf<typeof QrCodePageElement>;
